import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { BootstrapVue3 } from 'bootstrap-vue-3';
import ClickOutside from './directives/clickOutside';
import Focus from './directives/focus';
import ScrollEnd from './directives/scrollEnd';
import Shimmer from 'vue3-shimmer';
import { SnackbarService } from "vue3-snackbar";
import VueAwesomePaginate from "vue-awesome-paginate";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import "vue3-snackbar/styles";
import "vue-awesome-paginate/dist/style.css";
import textareaAutoresize from "@/directives/textareaAutoresize";
import i18n from './i18n';
import { QuillEditor } from "@vueup/vue-quill";
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import 'vue-multiselect/dist/vue-multiselect.css';
import "gridstack/dist/gridstack.min.css";
import "gridstack/dist/gridstack-extra.min.css";
import '@vuepic/vue-datepicker/dist/main.css'
import './assets/main.css'
import VueApexCharts from "vue3-apexcharts";
import * as Sentry from "@sentry/vue";
import tooltip from "@/directives/tooltip";
import VueKonva from 'vue-konva';
import { aiTextGenerator } from "@/directives/aiTextGenerator";
import moment from "moment";
import 'moment/locale/tr';
import Vue3Tour from 'vue3-tour';
import './assets/tour.css'
import { createPinia } from 'pinia'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
import 'flag-icons/css/flag-icons.min.css';

const app = createApp(App);
app.use(VueTelInput)


app.config.globalProperties.uploadStatus = [];
app.config.globalProperties.tourConfig = {
    useKeyboardNavigation: true,
    labels: {
        buttonSkip: i18n.global.t('buttonSkip'),
        buttonPrevious: i18n.global.t('buttonPrevious'),
        buttonNext: i18n.global.t('buttonNext'),
        buttonStop: i18n.global.t('buttonStop'),
    }
};

Sentry.init({
    app,
    dsn: "https://bb341fae91e5966cef8304cb4d366cc4@o4507786058006528.ingest.de.sentry.io/4507786063052880",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost"],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

const userLang = localStorage.getItem('userLanguage') || 'tr';
moment.locale(userLang === 'en' ? 'en' : 'tr');
app.config.globalProperties.$moment = moment;
app.use(i18n);
app.use(router);
app.use(BootstrapVue3);
app.use(Shimmer);
app.use(SnackbarService);
app.use(VueAwesomePaginate);
app.use(VueApexCharts);
app.use(VueKonva);
app.use(Vue3Tour);
app.use(createPinia())

app.directive('click-outside', ClickOutside);
app.directive('focus', Focus);
app.directive('scroll-end', ScrollEnd);
app.directive('textarea-autoresize', textareaAutoresize);
app.directive('tooltip', tooltip);
app.directive('ai-generator', aiTextGenerator);
app.component('QuillEditor', QuillEditor);

app.config.errorHandler = (err, vm, info) => {
    console.error("Error:", err);
    console.error("Vue component:", vm);
    console.error("Additional info:", info);
};

app.mount('#app');
